export enum EWhichDisplayTo {
    Group = 'Group',
    OrganizationRole = 'organization-roles',
  }